
import React, { Component } from 'react';
import { Checkbox } from 'antd';

export class DriverAccountStatus extends Component {

    handleAccountStatus = (value) => {
        const { onChange } = this.props;
        onChange(value);
    }

    render() {
        const { value, disabled, typeOption } = this.props;
        return (
            <div className="car-status">
                <Checkbox
                    disabled={disabled}
                    onChange={() => this.handleAccountStatus(true)}
                    checked={value === true}
                >
                    Active
                </Checkbox>
                <Checkbox 
                    disabled={disabled || typeOption === 'create_new'}
                    onChange={() => this.handleAccountStatus(false)}
                    checked={value === false}
                >
                    Inactive</Checkbox>
            </div>
        )
    }
}